export default __webpack_public_path__ + "static/favicon-144-538718a60602ec0d9ec040d8187bfe06.jpg";